import Portfolio from '../components/Portfolio'
import { ArrowLeft } from "lucide-react";
import { NavLink } from "react-router-dom";


function Home({ t, lang }) {
      return (
        <main className="page-container bg-custom">
            <div className='container text-center'>
              <div className='page-header'>
                <NavLink to="/medias"><ArrowLeft size={40} className='back-arrow' /></NavLink>
                <h1 className='page-title'>{t("photos").toUpperCase()}</h1>
              </div>
              <Portfolio t={t} lang={lang} />
            </div>
        </main>
      );
    }
    
    export default Home;